import { useEffect, useState } from "react";
import Label from "lib/Label";
import ErrorMessage from 'lib/ErrorMessage';
import "./index.scss";

import { gridValues } from "helper/destructureObject";

const Checkbox = (props) => {
  const { name, label,error, options, onChange, class_name, value, size,isEditable,validators // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  
  } = props;
  //let checkbox = [];
  let gridData = gridValues(null, options);
  let className = null;
  if (window.innerWidth > 750 && gridData.web < 12) {
    className = "w-50";
  }
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : ""
  const onhandleChange = (label) => {
    if (value != undefined) {
      if (value.includes(label)) {
        let updated = value.filter((item) => item != label);
        onChange(name, [...updated]);
      } else onChange(name, [...value, label]);
    } else {
      onChange(name, [label]);
    }

 };

  return (
    <>
      <Label label={label} validators={validators} />
      <div className={`${class_name ? class_name : "checkbox_container mx-0 row"} `}>
        {options?.map((option) => {
          const { id, label, for: htmlFor, checkbox_class } = option;
          let checkboxId = name + id;
          return (
            <div
              key={checkboxId}
              className={`!${checkbox_class? className + " " + size: checkbox_class + " " + size} ${size} .px-3`}
            >
              <div className={`checkbox p-2 ${errorClass}`}>
                <input
                  id={checkboxId}
                  type="checkbox"
                  name={name}
                  onChange={() => onhandleChange(label)}
                  disabled = {isEditable ? false:true}
                  // value=label}
                   checked={value && value.length? value.includes(label) ? true:false :false}
                />
                <label className="checkbox_label" htmlFor={checkboxId}>
                  {label}
                </label>
              </div>
            </div>
          );
        })}
      </div>
      {
                error?.length !== 0 && (
                    <ErrorMessage error={error} />
                )
            }
    </>
  );
};

export default Checkbox;
